import {Component} from 'react';
import {connect} from 'react-redux';
import {CoApplicantRelationshipTypes} from '@deliveriesondemand/dod-data';

import {renderFieldErrors, isMobile} from '-/util/util';
import NavigationService from '-/services/NavigationService';
import {Control, ControlGroup} from '-/components/fields/Control';
import {RadioGroup, Radio} from '-/components/fields/RadioGroup';
import ApiService from '-/services/ApiService';
import Button from '-/components/general/Button';
import Form from '-/components/fields/Form';
import Legend from '-/components/fields/Legend';
import TextInput from '-/components/fields/TextInput';

class AddCoApp extends Component {
    constructor() {
        super();

        this.state = {
            errorMessages: [],
            showErrors: false,
            checked: false
        };

        this.handleGoClick = this.handleGoClick.bind(this);
        this.handleRadioChange = this.handleRadioChange.bind(this);
    }

    handleRadioChange(e) {
        this.setState({
            checked: true,
            errorMessages: []
        });
        this.props.handleRadioChange(e);
    }

    getErrorMessages() {
        const {checked} = this.state;
        const {coApplicantTypeOther, coAppType} = this.props;
        const errors = [];

        if (coAppType === 'other' && !coApplicantTypeOther) {
            errors.push('Please describe the co-applicant relationship');
        }

        if (!checked) {
            errors.push('Please choose a co-applicant type.');
        }

        return errors;
    }

    handleGoClick() {
        const errorMessages = this.getErrorMessages();
        this.setState({errorMessages, showErrors: true});
        if (errorMessages.length <= 0) {
            this.props.handleGoClick();
        }
    }

    componentDidMount() {
        const {coAppType} = this.props;

        if (Object.keys(CoApplicantRelationshipTypes).includes(coAppType)) {
            this.setState({
                checked: true,
                errorMessages: []
            });
        }
    }

    renderCoAppOptions() {
        const {coAppType = 'coapplicant', coApplicantTypeOther, handleOtherChange} = this.props;
        const question = {
            label: 'Choose Co-applicant type',
            key: 'coapplicantType',
            options: Object.keys(CoApplicantRelationshipTypes).map(key => {
                const label = CoApplicantRelationshipTypes[key];

                return {
                    value: key,
                    label,
                    checked: key === coAppType
                };
            })
        };

        return (
            <ControlGroup>
                <Legend>{question.label}</Legend>
                <RadioGroup vertical={isMobile()}>
                    {question.options.map(option => {
                        const id = question.key + '_' + option.value;
                        return (
                            <Radio
                                key={id}
                                id={id}
                                label={option.label}
                                onChange={this.handleRadioChange}
                                name={question.key}
                                value={option.value}
                                checked={!!option.checked} />
                        );
                    })}
                </RadioGroup>
                {coAppType === 'other' && 
                    <Control>
                        <TextInput
                            label="Relationship"
                            placeholder="Friend, roommate, etc."
                            value={coApplicantTypeOther}
                            onChange={handleOtherChange} />
                    </Control>
                }
            </ControlGroup>
        );
    }

    renderCoApplicantOptions() {
        const {apiErrors} = this.props;
        const {errorMessages, showErrors} = this.state;

        return (
            <div>
                {this.renderCoAppOptions()}
                {showErrors ? renderFieldErrors([...errorMessages, ...apiErrors]) : null}
                <Button btnStyle="alternate" onClick={this.handleGoClick}>Go</Button>
            </div>
        );
    }

    render() {
        return (
            <div>
                <Form standalone={true}>
                    {this.renderCoApplicantOptions()}
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const apiErrors = ApiService.getErrors();

    return {
        apiErrors,
        reachedCoApp: state.navigation.reachedCoApp,
        coAppType: NavigationService.getReducerState().coApplicantType,
        coApplicantTypeOther: NavigationService.getReducerState().coApplicantTypeOther
    };
};

const mapDispatchToProps = dispatch => {
    return {
        handleRadioChange: e => {
            NavigationService.set('coApplicantType', e.target.value);
        },
        handleOtherChange: value => {
            NavigationService.set('coApplicantTypeOther', value);
        },
        handleGoClick: () => {
            dispatch(() => {
                const {buyerHasCoApp} = NavigationService.getReducerState() || {};
                const nextStep = buyerHasCoApp === 'YESPREVIOUSCOAPP' ? 'submit': 'buyerInfo';
                
                NavigationService.setReachedCoApp();
                NavigationService.next(nextStep);
                ApiService.save('none');
            });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddCoApp);
